// https://lincolnprofilev9.cms.dealer.com/lincoln-cpov-mbg.htm
export default {
	events: {
		widgetUserEvent: [
			{
				// hero "Search inventory" ws-content-cta button
				logic: {
					action: 'clicked',
					widgetName: 'ws-content-cta',
					widgetId: 'content-cta1'
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'cpo overview:mbgt:search inventory',
							onclickLinkName: 'cpo overview:mbgt:content:action'
						}
					}
				})
			},
			{
				logic: {
					action: 'clicked',
					widgetName: 'ws-accordion-content'
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'cpo overview:mbgt:content:accordion:[[eventData.elementCTA]]',
							onclickLinkName: 'cpo overview:mbgt:content:action'
						}
					}
				})
			}
		],
		'ddc.link.generic': [
			{
				// "Search inventory" links-list link
				logic: ({ eventData }) =>
					eventData?.attributes?.href?.includes?.(
						'/certified-inventory/index.htm'
					),
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'cpo overview:mbgt:search inventory',
							onclickLinkName: 'cpo overview:mbgt:content:action'
						}
					}
				})
			}
		]
	}
};
